import ReviewPage from './review-page.vue'
export default ReviewPage